<script>
export default {
    name: 'MessageContentImage',
    props: {
        content: {
            type: Object
        },
        time: {
            type: String
        },
        isVisitor: {
            type: Boolean
        }
    }
}
</script>

<template>
  <div class="d-flex flex-column" style="width: 80%">
    <div class="wrapper">
      <img class="image" :src="content.url" alt="image"/>
      <span>{{content.title}}</span>
      <button class="image-btn" v-for="btn of content.buttons" :key="btn.title">
        {{btn.title}}
      </button>
    </div>
    <span class="chat-time align-self-end">{{time | formatTimeHM}}</span>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  background: #F1F6FE;
  .image {
    width: 100%;
    object-fit: contain;
  }
  .image-title {
    color: #516C95;
  }
  .image-btn {
    padding: 10px;
    border-radius: 5px;
    background: #E0E9F6;
    font-weight: bold;
  }
}
.chat-time {
  color: #7B7B7B;
  font-size: 12px;
}
</style>
